<div class="container px-4 py-5 my-5 text-center bg-white rounded-4">
    <h1 class="display-5 fw-bold text-body-emphasis">Dorpelbestellen.nl</h1>
    <div class="col-lg-6 text-center mx-auto">
        <p class="mb-4"> Dit portaal is ingericht voor bestaande klanten van <a
                href="https://www.luvema.nl" target="_blank"><b>Luvema</b></a>.<br><br>Bent u nog geen klant of heeft u vragen neem dan
            <a href="https://www.luvema.nl/contact/" target="_blank"><b>contact</b></a> met ons op.<br><br>
            Wilt u alleen profielen bestellen? Dat kan op <a
                [href]="crossPortalLink" target="_blank"><b>profielbestellen.nl</b></a>
        </p>
    </div>
    <div class="row">
        <div class="col-6 d-grid gap-2 d-sm-flex justify-content-sm-center px-4 py-5 my-5">
            <button type="button" class="product-button" [routerLink]="['/order-form/Isowel']">
                <img class="rounded img-fluid " width="150" height="150" src="assets\isowel.jpg">
                <h4>Isowel Dorpels</h4>
            </button>
        </div>
        <div class="col-6 d-grid gap-2 d-sm-flex justify-content-sm-center px-4 py-5 my-5">
            <button type="button" class="product-button" [routerLink]="['/Luvema']">
                <img class="rounded img-fluid " width="150" height="150" src="assets\logo.jpg">
                <h4>Aluminium Dorpels</h4>
            </button>
        </div>

    </div>
</div>

<app-footer></app-footer>